<template>
  <el-dialog
    :visible.sync="loading"
    title=""
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    center
    top="48vh"
    class="spring-festival-draw draw-loading-dialog"
    :show-close="false"
  >
    <div class="draw-loading-box">
      <div class="draw-result" v-if="visible">
        <lottie
          :options="defaultOptions"
          :height="600"
          :width="600"
          @animCreated="handleAnimation"
        />
      </div>
      <div class="draw-loading" v-else>
        兌換中...
      </div>
    </div>
  </el-dialog>
</template>
<script>
import lottie from 'vue-lottie';

export default {
  name: 'UserRelation',
  components: {
    lottie
  },
  props: {
    loadingText: {
      type: String,
      default: '開啓中'
    },
    animationData: {
      default: null
    }
  },
  data() {
    return {
      loading: false,
      visible: false
    };
  },
  watch: {},
  computed: {
    defaultOptions() {
      return {
        loop: false,
        autoplay: true,
        animationData: this.animationData
      };
    }
  },
  methods: {
    // 显示抽奖结果
    handleAnimation(anim) {
      anim.onComplete = () => {
        this.closePop();
      };
    },
    // 關閉彈窗
    closePop() {
      this.$emit('end');
      this.loading = false;
      this.visible = false;
    },
    // 顯示彈窗
    openPop() {
      this.loading = true;
    },
    playAnimate() {
      this.visible = true;
    }
  }
};
</script>
<style lang="scss">
.spring-festival-draw {
  text-align: center;
  .el-dialog {
    border-radius: 14px;
    max-width: 400px;
  }
  .el-dialog__header {
    padding: 20px;
  }
  .el-dialog__body {
    padding: 20px;
    padding-top: 0;
  }
  .christmas-gitbox-buy-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .input-box {
      display: flex;
      align-items: center;
      // justify-content: center;
      padding-bottom: 20px;
    }
    .btn-confirm {
      width: 200px;
      border-radius: 44px;
    }
  }
  &.draw-loading-dialog {
    .el-dialog {
      background-color: inherit;
      box-shadow: none;
    }
    .draw-loading {
      font-size: 20px;
      text-align: center;
      color: white;
    }
    .draw-result {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      white-space: nowrap;
      color: #eeeeee;
      font-size: 40px;
      text-align: center;
      // width: 400px;
      img {
        max-width: 100%;
      }
    }
    .loading-icon {
      text-align: center;
      margin-bottom: 20px;
    }
  }
  &.christmas-give-gift {
    .el-input__inner {
      text-align: center;
    }
    .btn-box {
      margin-top: 40px;
      display: flex;
      justify-content: center;
    }
    .btn-confirm {
      width: 100px;
      border-radius: 44px;
    }
    .label-box {
      display: flex;
      justify-content: space-around;
      padding-bottom: 20px;
    }
  }
  .rules-item {
    margin-bottom: 10px;
  }
}
</style>
